import Button from 'components/UI/Button/Button';
import Checkbox from 'components/UI/Checkbox/Checkbox';
import Modal from 'components/UI/Modal/Modal';
import { useRootModal } from 'hooks/useRootModal';
import { useTranslate } from 'hooks/useTranslate';
import React, { useContext, useState } from 'react';
import { useAlert } from 'hooks/useAlert';
import './ExportModal.module.scss';
import { useDispatch } from 'react-redux';
import requestExport from 'actions/portfolio/requestExport';
import { MyPortfolioContext } from '../../MyPortfolio';

export default function ExportModal({ portfolioId }: { portfolioId: number }) {
  const [isChecked, setIsChecked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const translate = useTranslate();

  const { setExportModalOpen } = useContext(MyPortfolioContext);

  const { closeModal } = useRootModal();

  const handleClose = () =>
    setExportModalOpen ? setExportModalOpen(false) : closeModal();

  const dispatch = useDispatch();

  const alert = useAlert();

  const requestPdfExport = () => {
    // check
    setIsLoading(true);
    dispatch(
      requestExport({
        portfolioId,
      })
    )
      .then(() => {
        setIsLoading(false);
        handleClose();
        alert('Je ontvangt een mail met de export!', 'Gelukt');
      })
      .catch((e) => {
        alert('Er ging iets mis');
      });
  };

  return (
    <Modal setModalIsOpen={setExportModalOpen} size="medium" noCross>
      <div styleName="top">
        <h2>Portfolio exporteren</h2>
        <p>
          Met een export van je porfolio zie je per project alle beoordelingen
          en bewijsvoering. Vraag hier je export aan en je krijgt binnen enkele
          minuten een mail met de PDF.
        </p>
      </div>
      {/* <div styleName="checkboxes">
        <Checkbox isChecked={isChecked} setIsChecked={setIsChecked}>
          <p styleName={`check ${isChecked ? 'checked' : ''}`}>
            Alles selecteren
          </p>
        </Checkbox>
        <Checkbox isChecked={isChecked} setIsChecked={setIsChecked}>
          <p styleName={`check ${isChecked ? 'checked' : ''}`}>Vaardigheden</p>
        </Checkbox>
        <Checkbox isChecked={isChecked} setIsChecked={setIsChecked}>
          <p styleName={`check ${isChecked ? 'checked' : ''}`}>Bewijsvoering</p>
        </Checkbox>
        <Checkbox isChecked={isChecked} setIsChecked={setIsChecked}>
          <p styleName={`check ${isChecked ? 'checked' : ''}`}>Beoordeling</p>
        </Checkbox>
        <Checkbox isChecked={isChecked} setIsChecked={setIsChecked}>
          <p styleName={`check ${isChecked ? 'checked' : ''}`}>Projecten</p>
        </Checkbox>
      </div> */}
      <div styleName="button-wrapper ">
        <Button
          color="grey"
          onClick={() => {
            handleClose();
          }}
        >
          {translate('general.terms.cancel')}
        </Button>
        <Button inactive={isLoading} onClick={requestPdfExport}>
          Export aanvragen
        </Button>
        {/* TODO: translate */}
      </div>
    </Modal>
  );
}
